import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Map from "./map"

const ListOfPois = ({ map, search, pois }) => {
  const filteredPois = pois
  return <div>{map && <Map {...{ pois, filteredPois }} />}</div>
}

ListOfPois.propTypes = {
  map: PropTypes.bool,
  search: PropTypes.bool,
  pois: PropTypes.arrayOf(PropTypes.object),
}

export { ListOfPois }
